import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCategoriesWithGroups = (categories) => {
  return {
    type: actionTypes.SET_CATEGORIES_WITH_GROUPS,
    payload: categories
  }
}
